import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './Tooltip.module.css';

interface Props {
  title: string;
  text: string;
  onClose: () => void;
}

export const Tooltip = ({ title, text, onClose }: Props) => {
  return (
    <div className={styles.wrapper} onClick={onClose}>
      <div className={styles.header}>
        {title}
        <ThemeIcon icon="remove-gray" alt="Close" variant="inline" />
      </div>
      <div className={styles.content}>{text}</div>
    </div>
  );
};
